export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-agendamento' */ '@/views/ambulatorio/agendamento/Index'),
        path: 'agendamento',
        redirect: 'agendamento/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-agendamento' */'@/views/ambulatorio/agendamento/List.vue'),
                name: 'ambulatorio-agendamento-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-agendamento' */ '@/views/ambulatorio/agendamento/Form.vue'),
                name: 'ambulatorio-agendamento-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]